import fs from 'fs';
import path from 'path';

import fg from 'fast-glob';
import chalk from 'chalk';

import type { SemTree, GraftWarning } from 'semtree';
import * as semtree from 'semtree';

import { MD } from './const';
import { getConfig } from './config';
import { getIndexFileUris } from './util';


export interface InitTree {
  configUri: string;
  doctypeUri: string;
  rootFileName: string | undefined;
  globIndexUris: string | undefined;
}

export interface Node {
  text: string;
  ancestors: string[];
  children: string[];
}

export const ROOT_NAME : string = 'i.bonsai';

// build tree data

export function buildTreeData(indexFileUris: string[]): Record<string, string> {
  return indexFileUris.reduce((map, uri) => {
    try {
      const filename: string = path.basename(uri, path.extname(uri));
      const fileContent: string = fs.readFileSync(uri, 'utf-8').toString();
      map[filename] = fileContent;
    } catch (e) {
      console.warn(e);
    }
    return map;
  }, {} as Record<string, string>);
}

// build tree

export function buildTreeSync(payload: InitTree): SemTree | undefined {
  const rootFileName: string | undefined = getRootFileName(payload.configUri, payload.rootFileName);
  if (rootFileName === undefined) { return; }
  const indexFileUris: string[] | undefined = getIndexFileUris(payload.doctypeUri, payload.globIndexUris);
  if (indexFileUris === undefined) { return; }
  const treeData: Record<string, string> = buildTreeData(indexFileUris);
  if (Object.keys(treeData).length === 0) {
    console.error('error with tree data payload -- result was empty');
  }
  try {
    const tree: SemTree | string = semtree.create(rootFileName, treeData);
    if (typeof tree === 'string') {
      console.error(tree);
    } else {
      return tree;
    }
  } catch (e) {
    console.error(e);
  }
}

// tree-related file operations
export function getRootFileName(configPath: string | any, root: string | undefined): string | undefined {
  const config: any | undefined = (typeof configPath === 'string') ? getConfig(configPath) : configPath;
  const cwd: string = process.cwd();
  let rootName: string | undefined;
  if (root === undefined) {
    if (config && config.garden && config.garden.root) {
      rootName = config.garden.root;
    }
    if (rootName === undefined) { rootName = ROOT_NAME; }
  } else {
    rootName = root;
  }
  const files: string[] = fg.sync(cwd + '/**/' + rootName + MD);
  if ((files.length === 1) && files[0].indexOf(rootName) > -1) {
    return rootName;
  }
  console.warn(chalk.yellow('unable to find root with name: ' + '"' + rootName + '"'));
}

// graft warning display (CLI presentation layer)

export function analyzeGraftWarnings(
  lines: string[],
  ci: number,
  indexRelPath: string,
  indentWidth: number,
): void {
  const warning: GraftWarning | null = semtree.detectLastBranchRemoved(lines, ci, indexRelPath, indentWidth);
  if (!warning) {
    return;
  }
  console.warn(chalk.yellow(
    [
      'last branch under old parent removed',
      `  parent: [[${warning.oldParentName}]]`,
      `  index: ${warning.indexRelPath}`,
      `  block: ${warning.lineCount} line(s)  depth: ~${warning.depthLevels} level(s)`,
      '  note: orphan parent bullet possible — check indent / semtree',
    ].join('\n'),
  ));
}
